import dynamic from "next/dynamic";
const AdaChatbotIframeComponent = dynamic(()=>import("./ada-chatbot-iframe-component"));
import AdaChatbotIframeConfig from "./ada-chatbot-iframe-config";
import AdaChatbotIframeAdvancedConfig from "./ada-chatbot-iframe-advanced-config";
export default {
    AdaChatbotIframeComponent,
    AdaChatbotIframeConfig,
    AdaChatbotIframeAdvancedConfig
};
